import { Box, Flex, Image, Button, IconButton } from "@chakra-ui/react";
import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";
import { useState } from "react";
import { Link as RouterLink } from "react-router-dom"; // << use Router Link

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Box
      as="header"
      w="100%"
      bg="white"
      px={10}
      py={3}
      borderBottom="1px solid #E5E5E5"
      position="relative"
      zIndex={1000}
    >
      <Flex align="center" justify="space-between" position="relative">
        {/* Left spacer (keeps logo centered visually) */}
        <Box w="80px" />

        {/* Logo Centered as a Link to home (use RouterLink for client-side nav) */}
        <Flex
          position="absolute"
          left="50%"
          transform="translateX(-50%)"
          align="center"
          pointerEvents="none" // allow the child link to handle clicks
        >
          <RouterLink to="/" style={{ pointerEvents: "auto" }}>
            <Image
              src="/Pentagoan-logo.webp"
              alt="Pentagon Home Solutions Logo"
              height="38px"
              objectFit="contain"
            />
          </RouterLink>
        </Flex>

        {/* Right side - Contact button / Mobile Menu */}
        <Flex align="center">
          <Button
            as={RouterLink}
            to="/ContactUs" // <-- prefer lower-case route; match your route definitions
            borderRadius="md"
            bg="#0B1D39"
            color="white"
            px={6}
            py={2}
            fontWeight="medium"
            fontSize="sm"
            _hover={{
              bg: "white",
              color: "#0B1D39",
              border: "1px solid #0B1D39",
            }}
            display={{ base: "none", md: "inline-flex" }}
          >
            Contact us
          </Button>

          {/* Mobile Hamburger */}
          <IconButton
            size="md"
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            aria-label="Toggle Menu"
            display={{ base: "inline-flex", md: "none" }}
            onClick={() => setIsOpen(!isOpen)}
            bg="#0B1D39"
            color="white"
            ml={2}
            _hover={{ bg: "#C9A14A", color: "white" }}
          />
        </Flex>
      </Flex>
    </Box>
  );
}
